import { FORM_FACTORS_MAP } from '../../constants';
import { FormFactor } from '../../types';

export const getFormFactor = (deviceFormFactor: FormFactor): FormFactor =>
  deviceFormFactor === FORM_FACTORS_MAP.TABLET
    ? FORM_FACTORS_MAP.MOBILE
    : deviceFormFactor;
